import { UnicodeEntity } from '@mews/enums';
import { LocalizedText, PLATFORM_STATUS_URL, useIsLocalizationInitialized } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Link } from '@optimus-web/core';
import { SmallContentContainer } from '../layout';

export const DefaultErrorHandler = () => {
    // in case the error boundary is used outside of localization context
    const isLocalizationInitialized = useIsLocalizationInitialized();

    return (
        <SmallContentContainer>
            <Banner
                primaryText={
                    isLocalizationInitialized ? <LocalizedText textKey={TextKey.UnexpectedError} /> : 'Unexpected error'
                }
                secondaryText={
                    <>
                        {isLocalizationInitialized ? (
                            <LocalizedText textKey={TextKey.UnexpectedErrorMessage} />
                        ) : (
                            'Try accessing the page later or contact support. You may also check our Status Page at'
                        )}
                        {UnicodeEntity.NoBreakSpace}
                        <Link target="_blank" rel="noreferrer" href={PLATFORM_STATUS_URL}>
                            {PLATFORM_STATUS_URL}
                        </Link>
                    </>
                }
                variant="error"
            />
        </SmallContentContainer>
    );
};
